import React from 'react';

import { NumberInput, NumberInputProps } from '@mantine/core';
import { useLocalization } from 'context/localization-context';
import { Country } from 'types/enums';

type SelectComponentProps = React.ComponentProps<typeof NumberInput> & any;
type ByCountryProps = Partial<Record<Country, Partial<SelectComponentProps>>>;

interface IMoneyFieldProps extends Omit<NumberInputProps, 'formatter' | 'parser' | 'precision' | 'step'> {
  country: Country | undefined;
  byCountryProps?: ByCountryProps;
}

const MoneyField = ({
  country,
  byCountryProps,
  min,
  ...numberInputProps
}: IMoneyFieldProps): JSX.Element => {
  const { formatCurrency } = useLocalization(country);
  const countrySpecificProps = country ? byCountryProps?.[country] : {};

  const parser = (value: string): string => {
    // Remove currency symbols, spaces, and commas
    return value.replace(/[^\d.-]/g, '');
  };

  const formatter = (value?: string): string => {
    if (!value || value === '' || Number.isNaN(parseFloat(value))) {
      return formatCurrency(0);
    }
    return formatCurrency(parseFloat(value));
  };

  return (
    <NumberInput
      parser={parser}
      formatter={formatter}
      precision={2}
      min={min || 0}
      step={0.01}
      {...numberInputProps}
      {...countrySpecificProps}
    />
  );
};

export default MoneyField;
